'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.namespaces = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseURLQuery = parseURLQuery;
exports.parseXml = parseXml;
exports.getElements = getElements;
exports.getFirstElement = getFirstElement;
exports.getText = getText;
exports.getAttributeNS = getAttributeNS;
exports.simplePath = simplePath;
exports.lookupPrefix = lookupPrefix;
exports.fetchAndCheck = fetchAndCheck;
exports.isNullOrUndefined = isNullOrUndefined;
exports.toWKT = toWKT;
exports.createRequest = createRequest;
exports.createXHR = createXHR;
exports.find = find;
exports.assign = assign;

require('isomorphic-fetch');

/**
 * @module opensearch/utils
 */

function parseURLQuery(url) {
  var search = url.indexOf('?') === -1 ? url : url.substring(url.indexOf('?'));
  var vars = search.split('&');
  var parsed = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    parsed[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return parsed;
}

function parseXml(xmlStr) {
  if (typeof DOMParser !== 'undefined') {
    return new DOMParser().parseFromString(xmlStr, 'text/xml');
  } else if (typeof ActiveXObject !== 'undefined') {
    var xmlDoc = new ActiveXObject('Microsoft.XMLDOM'); // eslint-disable-line no-undef
    xmlDoc.async = 'false';
    xmlDoc.loadXML(xmlStr);
    return xmlDoc;
  }
  throw new Error('Could not parse XML document.');
}

/*
 * Some common namespace definitions
 */
var namespaces = exports.namespaces = {
  os: 'http://a9.com/-/spec/opensearch/1.1/',
  parameters: 'http://a9.com/-/spec/opensearch/extensions/parameters/1.0/',
  atom: 'http://www.w3.org/2005/Atom',
  georss: 'http://www.georss.org/georss',
  dc: 'http://purl.org/dc/elements/1.1/',
  media: 'http://search.yahoo.com/mrss/',

  // EOP and OM related namespaces
  opt: 'http://www.opengis.net/opt/2.1',
  om: 'http://www.opengis.net/om/2.0',
  eop: 'http://www.opengis.net/eop/2.0'
};

/*
 * Get an array of all child elements
 */
function getChildren(element) {
  if (element.children) {
    return Array.from(element.children);
  }
  return Array.from(element.childNodes).filter(function (node) {
    return node.nodeType === 1;
  }); // Node.ELEMENT_NODE
}

/*
 * Get an array of all *direct* descendants (in contrast to getElementsByTagName)
 * of an element with a certain namespace URI and tag name.
 */
function getElements(element, namespace, tagName) {
  var usedNamespaces = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : namespaces;

  if (!element) {
    return [];
  }
  var namespaceURI = usedNamespaces[namespace] || namespace;
  var children = getChildren(element);
  if (tagName && namespaceURI) {
    return children.filter(function (child) {
      return child.localName === tagName && child.namespaceURI === namespaceURI;
    });
  } else if (tagName) {
    return children.filter(function (child) {
      return child.localName === tagName;
    });
  }
  return children;
}

/*
 * Get the first direct descendant element with the given namespace URI and tag name.
 */
function getFirstElement(element, namespace, tagName, usedNamespaces) {
  // use shortcut; when available
  if (!namespace && !tagName && element.firstElementChild) {
    return element.firstElementChild;
  }
  var elements = getElements(element, namespace, tagName, usedNamespaces);
  if (elements.length) {
    return elements[0];
  }
  return null;
}

/*
 * Get the text of the first direct descendant element with the given namespace
 * URI and tag name.
 */
function getText(element, namespace, tagName, usedNamespaces) {
  var first = getFirstElement(element, namespace, tagName, usedNamespaces);
  return first ? first.textContent : null;
}

/*
 * Get the value of the namespaced attribute or return a default.
 */
function getAttributeNS(node, namespace, name, defaultValue) {
  var usedNamespaces = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : namespaces;

  var namespaceURI = usedNamespaces[namespace] || namespace;
  if (node.hasAttributeNS(namespaceURI, name)) {
    return node.getAttributeNS(namespaceURI, name);
  }
  return defaultValue;
}

function splitNamespace(name) {
  return name.indexOf(':') !== -1 ? name.split(':') : [null, name];
}

/**
 * Resolves an xPath like query with the given element as basis. All parts of
 * the path must be specified, none may be omitted. Allows to select attributes
 * using the `@attrName` postfix or the text of an element using the `text()`
 * as the last path part.
 * @param {object} element The root element to start the query on. Must be a DOM
 *                         compliant object.
 * @param {string} path The search path: parts are separated by the `/` character
 *                      and may contain a supported namespace prefix (separated
 *                      by the color character).
 *                      Examples: `os:Url@type`, `atom:entry/atom:title/text()`,
 *                      `channel/item/georss:box/text()`
 * @param {boolean} [single=false] Whether multiple elements are expected. When
 *                                 false, an array is returned, otherwise single
 *                                 values.
 * @returns {object|string|object[]|string[]} Depending on the query and the
 *                                            single parameter, either a DOM Node
 *                                            or a string, or arrays thereof.
 */
function simplePath(element, path) {
  var single = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var usedNamespaces = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  // split path and discard empty parts
  var parts = path.split('/').filter(function (part) {
    return part.length;
  });
  var current = single ? element : [element];

  for (var i = 0; i < parts.length; ++i) {
    var part = parts[i];

    // single values are treated differently
    if (single) {
      if (part === 'text()') {
        return current.textContent;
      } else if (part.indexOf('@') !== -1) {
        var _part$split = part.split('@'),
            _part$split2 = _slicedToArray(_part$split, 2),
            nodePart = _part$split2[0],
            attrPart = _part$split2[1];

        var _splitNamespace = splitNamespace(nodePart),
            _splitNamespace2 = _slicedToArray(_splitNamespace, 2),
            _namespace = _splitNamespace2[0],
            _tagName = _splitNamespace2[1];

        var _splitNamespace3 = splitNamespace(attrPart),
            _splitNamespace4 = _slicedToArray(_splitNamespace3, 2),
            attrNamespace = _splitNamespace4[0],
            attrName = _splitNamespace4[1];

        current = getFirstElement(current, _namespace, _tagName, usedNamespaces);
        return current ? getAttributeNS(current, attrNamespace, attrName, undefined, usedNamespaces) : null;
      }

      var _splitNamespace5 = splitNamespace(part),
          _splitNamespace6 = _slicedToArray(_splitNamespace5, 2),
          namespace = _splitNamespace6[0],
          tagName = _splitNamespace6[1];

      current = getFirstElement(current, namespace, tagName, usedNamespaces);
      if (!current) {
        return null;
      }
    } else if (part === 'text()') {
      return current.map(function (currentElement) {
        return currentElement.textContent;
      });
    } else if (part.indexOf('@') !== -1) {
      var _ret = function () {
        var _part$split3 = part.split('@'),
            _part$split4 = _slicedToArray(_part$split3, 2),
            nodePart = _part$split4[0],
            attrPart = _part$split4[1];

        var _splitNamespace7 = splitNamespace(nodePart),
            _splitNamespace8 = _slicedToArray(_splitNamespace7, 2),
            namespace = _splitNamespace8[0],
            tagName = _splitNamespace8[1];

        var _splitNamespace9 = splitNamespace(attrPart),
            _splitNamespace10 = _slicedToArray(_splitNamespace9, 2),
            attrNamespace = _splitNamespace10[0],
            attrName = _splitNamespace10[1];

        return {
          v: current.map(function (currentElement) {
            return getElements(currentElement, namespace, tagName, usedNamespaces);
          }).reduce(function (acc, value) {
            return acc.concat(value);
          }, []).map(function (finalElement) {
            return getAttributeNS(finalElement, attrNamespace, attrName, undefined, usedNamespaces);
          })
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    } else {
      (function () {
        var _splitNamespace11 = splitNamespace(part),
            _splitNamespace12 = _slicedToArray(_splitNamespace11, 2),
            namespace = _splitNamespace12[0],
            tagName = _splitNamespace12[1];

        current = current.map(function (currentElement) {
          return getElements(currentElement, namespace, tagName, usedNamespaces);
        }).reduce(function (acc, value) {
          return acc.concat(value);
        }, []);
      })();
    }
  }

  return current;
}

// adapted from https://developer.mozilla.org/en-US/Add-ons/Code_snippets/LookupPrefix
// Private function for lookupPrefix only
// eslint-disable-next-line no-underscore-dangle
function _lookupNamespacePrefix(namespaceURI, originalElement) {
  var xmlnsPattern = /^xmlns:(.*)$/;
  if (originalElement.namespaceURI && originalElement.namespaceURI === namespaceURI && originalElement.lookupNamespaceURI(originalElement.prefix) === namespaceURI) {
    return originalElement.prefix;
  }
  if (originalElement.attributes && originalElement.attributes.length) {
    for (var i = 0; i < originalElement.attributes.length; i++) {
      var att = originalElement.attributes[i];
      xmlnsPattern.lastIndex = 0;
      var localName = att.localName || att.name.substr(att.name.indexOf(':') + 1); // latter test for IE which doesn't support localName
      if (localName.indexOf(':') !== -1) {
        // For Firefox when in HTML mode
        localName = localName.substr(att.name.indexOf(':') + 1);
      }
      if (xmlnsPattern.test(att.name) && att.value === namespaceURI) {
        return localName;
      }
    }
  }
  if (originalElement.parentNode) {
    // EntityReferences may have to be skipped to get to it
    return _lookupNamespacePrefix(namespaceURI, originalElement.parentNode);
  }
  return null;
}

/**
 * Looks up the the namespace prefix on the given DOM Node and the given namespace
 * @param {DOMNode} node The node to look up the namespace prefix
 * @param {String} namespaceURI The namespace URI to look up the namespace definition
 * @returns {String} The namespace prefix
 */
function lookupPrefix(node, namespaceURI) {
  // Depends on private function _lookupNamespacePrefix() below and on https://developer.mozilla.org/En/Code_snippets/LookupNamespaceURI
  // http://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
  // http://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
  // (The above had a few apparent 'bugs' in the pseudo-code which were corrected here)
  if (node.lookupPrefix) {
    // Shouldn't use this in text/html for Mozilla as will return null
    return node.lookupPrefix(namespaceURI);
  }
  if (namespaceURI === null || namespaceURI === '') {
    return null;
  }
  switch (node.nodeType) {
    case 1:
      // Node.ELEMENT_NODE
      return _lookupNamespacePrefix(namespaceURI, node);
    case 9:
      // Node.DOCUMENT_NODE
      return _lookupNamespacePrefix(namespaceURI, node.documentElement);
    case 6: // Node.ENTITY_NODE
    case 12: // Node.NOTATION_NODE
    case 11: // Node.DOCUMENT_FRAGMENT_NODE
    case 10:
      // Node.DOCUMENT_TYPE_NODE
      return null; // type is unknown
    case 2:
      // Node.ATTRIBUTE_NODE
      if (node.ownerElement) {
        return _lookupNamespacePrefix(namespaceURI, node.ownerElement);
      }
      return null;
    default:
      if (node.parentNode) {
        // EntityReferences may have to be skipped to get to it
        return _lookupNamespacePrefix(namespaceURI, node.parentNode);
      }
      return null;
  }
}

function fetchAndCheck() {
  return fetch.apply(undefined, arguments).then(function (response) {
    if (response.status >= 400) {
      throw new Error('Bad response from server');
    }
    return response;
  });
}

function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}

/*
 * Forked from https://github.com/mapbox/wellknown/blob/87965f6f46ee38355e7e1f82107aa832ea29bc6c/wellknown.js
 * Removed whitespaces after geometry type to be more robust with some (FedEO)
 * services.
 */

/* eslint-disable no-param-reassign, prefer-template */

function toWKT(gj) {
  if (gj.type === 'Feature') {
    gj = gj.geometry;
  }

  function wrapParens(s) {
    return '(' + s + ')';
  }

  function pairWKT(c) {
    return c.join(' ');
  }

  function ringWKT(r) {
    return r.map(pairWKT).join(', ');
  }

  function ringsWKT(r) {
    return r.map(ringWKT).map(wrapParens).join(', ');
  }

  function multiRingsWKT(r) {
    return r.map(ringsWKT).map(wrapParens).join(', ');
  }

  switch (gj.type) {
    case 'Point':
      return 'POINT(' + pairWKT(gj.coordinates) + ')';
    case 'LineString':
      return 'LINESTRING(' + ringWKT(gj.coordinates) + ')';
    case 'Polygon':
      return 'POLYGON(' + ringsWKT(gj.coordinates) + ')';
    case 'MultiPoint':
      return 'MULTIPOINT(' + ringWKT(gj.coordinates) + ')';
    case 'MultiPolygon':
      return 'MULTIPOLYGON(' + multiRingsWKT(gj.coordinates) + ')';
    case 'MultiLineString':
      return 'MULTILINESTRING(' + ringsWKT(gj.coordinates) + ')';
    case 'GeometryCollection':
      return 'GEOMETRYCOLLECTION(' + gj.geometries.map(toWKT).join(', ') + ')';
    default:
      throw new Error('stringify requires a valid GeoJSON Feature or geometry object as input');
  }
}

/* eslint-enable no-param-reassign, prefer-template */

/**
 * Returns a [Request]{@link https://developer.mozilla.org/en-US/docs/Web/API/Request}
 * object for the fetch API.
 * @param {string} url The request URL
 * @param {object} [baseRequest] the baseRequest
 * @returns {Request} The constructed request.
 */
function createRequest(url, baseRequest) {
  return new Request(url, baseRequest);
}

/**
 * Creates (and sends) an [XMLHttpRequest]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest}.
 * @param {string} url The request URL
 * @param {object} [baseRequest] the baseRequest
 * @returns {XMLHttpRequest} The constructed request.
 */
function createXHR(url) {
  var baseRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var xhr = new XMLHttpRequest();
  xhr.open(baseRequest.method || 'GET', url);
  if (baseRequest.headers) {
    Object.keys(baseRequest.headers).forEach(function (key) {
      xhr.setRequestHeader(key, baseRequest.headers[key]);
    });
  }
  xhr.send(baseRequest.body ? baseRequest.body : null);
  return xhr;
}

/**
 * Sort of polyfill for [Array.prototype.find]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find}
 * @param {Array} arr the array to find the entry on.
 * @param {function} predicate the callback to find the value.
 * @param {*} thisArg the `this` for the predicate function.
 * @returns {*} the found item or undefined
 */
function find(arr, predicate, thisArg) {
  if (Array.prototype.find) {
    return arr.find(predicate, thisArg);
  }
  for (var i = 0; i < arr.length; ++i) {
    var v = arr[i];
    if (predicate(v, i, arr)) {
      return v;
    }
  }
  return undefined;
}

/**
 * Sort of polyfill for [Object.assign]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign}
 * @param {object} target the target to set the properties on.
 * @param {...object} sources the source objects to copy properties from.
 * @returns {object} the target
 */
function assign(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (Object.assign) {
    return Object.assign.apply(Object, [target].concat(sources));
  }
  for (var i = 0; i < sources.length; ++i) {
    var source = sources[i];
    if (source) {
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]; // eslint-disable-line no-param-reassign
        }
      }
    }
  }
  return target;
}


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/utils.js